import { FunctionComponent } from "react"
import { styled, StyleProps } from "../styles"
import { Text, TextProps } from "../Typography"

const Title = styled(Text as FunctionComponent<TextProps>)((props: StyleProps) => ({
  ...props.theme.fonts.subHeading,
  marginBottom: props.theme.spacing(2),
}))

Title.displayName = `Message.Title`

export { Title }
